var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MMCard',{attrs:{"title":"手机查看"}},[_c('template',{slot:"content"},[_c('img',{attrs:{"src":_vm.nowUrl,"alt":""}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }